import { __awaiter } from "tslib";
import JsxComponent from '@slickdeals/blueprint-twig/javascript/core/jsxComponent';
import Image from '@slickdeals/blueprint-twig/javascript/components/image';
import LinkableButton from '@slickdeals/blueprint-twig/javascript/components/linkableButton';
import { modifiers as ButtonModifiers } from '@slickdeals/blueprint-twig/javascript/components/button';
// The name of the module
export const name = 'CashbackSearchResultsBanner';
/** Class names for the component */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-cashbackSearchResultsBanner";
    ClassNames["JavaScript"] = "js-cashbackSearchResultsBanner";
    ClassNames["Active"] = "bp-p-cashbackSearchResultsBanner--active";
    ClassNames["Loud"] = "bp-p-cashbackSearchResultsBanner--loud";
    ClassNames["Muted"] = "bp-p-cashbackSearchResultsBanner--muted";
    ClassNames["Logo"] = "bp-p-cashbackSearchResultsBanner_img";
    ClassNames["Copy"] = "bp-p-cashbackSearchResultsBanner_copy";
    ClassNames["Highlight"] = "bp-p-cashbackSearchResultsBanner_copy--highlight";
    ClassNames["Price"] = "bp-p-cashbackSearchResultsBanner_copy--price";
    ClassNames["Subtext"] = "bp-p-cashbackSearchResultsBanner_copy--subtext";
    ClassNames["Button"] = "bp-p-cashbackSearchResultsBanner_button";
    ClassNames["Deal"] = "bp-p-cashbackSearchResultsBanner_deal";
})(ClassNames || (ClassNames = {}));
class CashbackSearchResultsBanner extends JsxComponent {
    constructor() {
        super(name);
    }
    /**
     * Returns the banner
     *
     * @param bannerProps Required properties to populate the banner
     * @returns {HTMLElement}
     */
    createElement(bannerProps) {
        const banner = this.createContext(bannerProps);
        this.getButton(bannerProps, banner);
        return banner;
    }
    /**
     * Returns the scaffolding for the banner
     *
     * @param bannerProps Required properties to populate the banner
     * @returns {HTMLElement}
     */
    createContext(bannerProps) {
        const classNames = [ClassNames.Default];
        if (bannerProps.testVariant === 'Loud') {
            classNames.push(ClassNames.Loud);
        }
        else if (bannerProps.testVariant === 'Muted') {
            classNames.push(ClassNames.Muted);
        }
        let content;
        if (bannerProps.testVariant === 'Loud') {
            content = this.getLoudVariantContent(bannerProps);
        }
        else if (bannerProps.testVariant === 'Muted') {
            content = this.getMutedVariantContent(bannerProps);
        }
        else {
            content = this.getControlContent(bannerProps);
        }
        return (JsxComponent.parseJsx("div", { className: classNames.join(' '), "data-promo-type": "cashbackSearchResultsBanner", "data-tracking-key": bannerProps.trackingKey, "data-variant-type": bannerProps.testVariant },
            this.getBannerLogo(bannerProps),
            content));
    }
    /**
     * Creates and assigns a blueprint image component to a private variable
     *
     * @param testVariant determines which asset to use
     */
    getBannerLogo({ testVariant }) {
        let width, height, src;
        if (testVariant === 'Loud' || testVariant === 'Muted') {
            width = 36;
            height = 36;
            src = '/image-pool/loyalty/search/loyaltyIconSearch.svg';
        }
        else {
            width = 54;
            height = 38;
            src = '/image-pool/loyalty/dollarStack.svg';
        }
        const image = Image.createElement({
            'width': width,
            'height': height,
            'src': src,
        });
        image.classList.add(`${ClassNames.Logo}`);
        return image;
    }
    /**
     * Appends a blueprint linkable button component to the banner
     *
     * @param ctaText from offer data from backend
     * @param ctaUrl from offer data from backend
     * @param container scaffolded banner, function appends a button asynchronously
     */
    getButton({ ctaText, ctaUrl, testVariant }, container) {
        return __awaiter(this, void 0, void 0, function* () {
            const infoCta = new LinkableButton({
                'element': LinkableButton.createElement(ctaText, [ButtonModifiers.large, ButtonModifiers.secondary]),
                'popup': true,
                'href': ctaUrl,
            });
            yield infoCta.isElementAvailable();
            const infoCtaElm = infoCta.getElement();
            infoCtaElm.classList.add(`${ClassNames.Button}`);
            if (testVariant) {
                infoCtaElm.dataset.variantType = `Loyalty Cashback Search Banner - ${testVariant}`;
            }
            this.linkableButton = infoCtaElm;
            container.appendChild(this.linkableButton);
        });
    }
    /**
     * Below methods return banner content for each test variant type
     *
     * @param cashbackRate from offer data from backend
     * @param storeName from offer data from backend
     */
    getLoudVariantContent({ cashbackRate, storeName }) {
        return (JsxComponent.parseJsx("div", { className: ClassNames.Copy },
            "Get ",
            cashbackRate,
            " via Slickdeals Rewards and Auto-Apply Coupons at ",
            storeName));
    }
    getMutedVariantContent({ cashbackRate, storeName }) {
        return (JsxComponent.parseJsx("div", { className: ClassNames.Copy },
            JsxComponent.parseJsx("div", { className: "mainDealInfo" },
                JsxComponent.parseJsx("div", { className: ClassNames.Deal },
                    JsxComponent.parseJsx("div", { className: ClassNames.Highlight },
                        "Get ",
                        cashbackRate,
                        " and Auto-Apply Coupons at ",
                        storeName),
                    JsxComponent.parseJsx("div", { className: ClassNames.Subtext }, "Install now to get the best coupons auto-applied to your cart while earning Cashback"))),
            JsxComponent.parseJsx("div", { className: "priceCol" },
                JsxComponent.parseJsx("div", { className: ClassNames.Price },
                    "Free",
                    JsxComponent.parseJsx("span", { className: "icon icon-fire" })),
                JsxComponent.parseJsx("div", { className: ClassNames.Subtext }, "Slickdeals Rewards"))));
    }
    getControlContent({ cashbackRate, storeName }) {
        return (JsxComponent.parseJsx("div", { className: ClassNames.Copy },
            "Automatically Apply Coupons and Get",
            JsxComponent.parseJsx("span", { className: ClassNames.Highlight },
                " ",
                cashbackRate,
                " "),
            "at ",
            storeName));
    }
}
export default CashbackSearchResultsBanner;
